<div class="cw-dialog settings-popup">
  <h2>{{ 'GENERAL.SETTINGS' | translate }}</h2>
  <div class="cw-horizontalline"></div>

  <!-- Alle zur Verfügung stehenden Einstellungen als Buttons anzeigen -->
  @if (selectedSetting == '') {
    <phscw-global-settings-changecolortheme> </phscw-global-settings-changecolortheme>
    <div class="cw-button-wrapper">
      <button
        mat-raised-button
        type="button"
        color="accent"
        [disabled]="!settingsPasswordEnabled"
        (click)="clickSettingsButton('password')">
        {{ 'GLOBAL.CHANGEPASSWORD.ACTION' | translate }}
      </button>
    </div>
    @if (settingsSelectDeputyEnabled) {
      <div class="cw-button-wrapper">
        <button
          mat-raised-button
          type="button"
          color="accent"
          [disabled]="!settingsSelectDeputyEnabled"
          (click)="clickSettingsButton('selectDeputy')">
          {{ 'GLOBAL.SETTINGS.SELECTDEPUTY' | translate }}
        </button>
      </div>
    }
    <div class="cw-button-wrapper">
      <button
        mat-raised-button
        type="button"
        color="accent"
        [disabled]="!settingsLanguageEnabled"
        (click)="clickSettingsButton('language')">
        {{ 'GLOBAL.CHANGELANGUAGE.ACTION' | translate }}
      </button>
    </div>
    <div class="cw-button-wrapper">
      <button mat-raised-button color="primary" type="button" (click)="clickAndClose()">
        {{ 'GENERAL.CLOSE' | translate }}
      </button>
    </div>
  }

  <!-- Falls Passwort geändert werden soll -->
  @if (selectedSetting == 'selectDeputy') {
    <phscw-global-settings-select-deputy (buttonCloseClicked)="clickSettingsClose()">
    </phscw-global-settings-select-deputy>
  }

  <!-- Falls Passwort geändert werden soll -->
  @if (selectedSetting == 'password') {
    <phscw-global-settings-changepassword
      [disableClose]="dialogRef.disableClose"
      (buttonCloseClicked)="clickSettingsClose()">
    </phscw-global-settings-changepassword>
  }

  <!-- Falls Sprache geändert werden soll -->
  @if (selectedSetting == 'language') {
    <phscw-global-settings-changelanguage
      (buttonCloseClicked)="clickSettingsClose()"
      (languageSaved)="clickLanguageSaved()">
    </phscw-global-settings-changelanguage>
  }
</div>
